import { render, staticRenderFns } from "./ConferenceView.vue?vue&type=template&id=48da0d13&"
import script from "./ConferenceView.vue?vue&type=script&lang=ts&"
export * from "./ConferenceView.vue?vue&type=script&lang=ts&"
import style0 from "./ConferenceView.vue?vue&type=style&index=0&id=48da0d13&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48da0d13')) {
      api.createRecord('48da0d13', component.options)
    } else {
      api.reload('48da0d13', component.options)
    }
    module.hot.accept("./ConferenceView.vue?vue&type=template&id=48da0d13&", function () {
      api.rerender('48da0d13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/ConferenceView.vue"
export default component.exports